// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @18/04/2023 14:55:52
import { CFormLink_abstract } from '../abstract/SagaSchema/CFormLink_abstract';
export class CFormLink extends CFormLink_abstract {}
